import React from 'react';
import { Controller } from 'react-hook-form';
import { FormControl, FormLabel, FormHelperText, NativeSelect, Box, Typography } from '@mui/material';
import { US_STATES } from './rh-us-state-select-element';

const USStateSelectNative = ({ name, label, control, required, helperText, rules }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <FormControl fullWidth error={!!error} required={required}>
          <FormLabel>{label}</FormLabel>
          <NativeSelect
            {...field}
            value={field.value || ''}
            onChange={(e) => field.onChange(e.target.value)}
            onBlur={field.onBlur}
          >
            <option value="">-- Select State --</option>
            {US_STATES.map((state) => (
              <option key={state.code} value={state.code}>
                {state.name} ({state.code})
              </option>
            ))}
          </NativeSelect>
          {error ? (
            <FormHelperText>{error.message}</FormHelperText>
          ) : (
            helperText && <FormHelperText>{helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};

export default USStateSelectNative;
